import React from "react";
import Select from "react-select";

const SelectCfdi = (props) => {
  const options = [
    { value: "G01", label: "G01 - Adquisición de mercancías" },
    { value: "P01", label: "P01 - Por definir" },
    { value: "G03", label: "G03 - Gastos en general" },
  ];

  const detectarCambiosCfdi = (selectedOption) => {
    props.detectarCambiosCfdi(selectedOption);
  };

  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
  };

  return (
    <Select
      required
      options={options}
      value={props.selectedOption}
      onChange={detectarCambiosCfdi}
      placeholder="Selecciona el CFDI"
      styles={selectStyles}
    />
  );
};

export default SelectCfdi;
